import type { PostgrestFilterBuilder } from '@supabase/postgrest-js';
import type { GenericSchema } from '@supabase/supabase-js/dist/module/lib/types';
export type NumberFilter = number | { gte?: number; lte?: number; gt?: number; lt?: number; };

export namespace NumberFilter {
    export function populate<
        // TBuilder extends PostgrestFilterBuilder<TSchema, TRow, TResult>,
        TSchema extends GenericSchema,
        TRow extends Record<string, unknown>,
        TResult,
        TKey extends string & keyof TRow,
    >(cur: PostgrestFilterBuilder<TSchema, TRow, TResult>, value: NumberFilter, key: TKey): PostgrestFilterBuilder<TSchema, TRow, TResult> {
        let q = cur;
        if (typeof value === 'number') {
            q = q.eq(key, value as any);
        } else {
            const { gte, lte, gt, lt } = value;
            if (gte) {
                q = q.gte(key, gte);
            }
            if (lte) {
                q = q.lte(key, lte);
            }
            if (gt) {
                q = q.gt(key, gt);
            }
            if (lt) {
                q = q.lt(key, lt);
            }
        }

        return q;
    }
}
